import View, {Notification} from "../framework/view";
import template from "../../pugc/fakebook";
import Server from "../server";
import {ShopItem} from "../bo/shop_item";
import {PaymentElementView} from "./payment_element";
import {renderEuros} from "../misc/utils";
import { User } from "../bo/user";
import {SignupView} from "./signup";
import {SignupForm, SignupNotification} from "./signup_form";
import {data} from "jquery";
import Alerts from "../misc/alerts";

const BIG_TANGO_FAKE_BOOK = "Big Tango Fake Book";

export default class FakebookView extends View {

    static classname = "fakebook-view";

    private server = Server.instance();

    private user?: User;

    private signup?: SignupForm;

    private url : string | undefined | false = undefined;

    private item: ShopItem | undefined = undefined;

    private paymentElementView? : PaymentElementView;

    private result: string | undefined;

    constructor() {
        super(FakebookView.classname);
        this.setup();
    }

    async setup() {

        this.user = await this.server.loginRemembered();

        if (this.user) {

            const result = await this.server.getBalance();
            // @ts-ignore
            const balances : { [ acctType: string] : number } | undefined = result.balances;

            if (balances) {
                const accts = Object.keys(balances).filter(acct => acct == BIG_TANGO_FAKE_BOOK);

                const acct = accts[0];
                const balance = acct && balances[acct];

                if (balance > 0) {
                    this.url = await this.server.getFakebookUrl();
                }
            }
            this.signup = undefined;
        } else {
            this.signup = new SignupForm(false);
            this.signup.autologin = true;
        }

        if (! this.url) {
            const catalogue = await this.server.fetchShopCatalogue();

            const fb = catalogue.filter(i => i.description && i.description == BIG_TANGO_FAKE_BOOK);
            if (fb.length > 0) {
                this.item = fb[0];
            }
            if (this.item && this.item.cents && this.user) {
                this.paymentElementView = new PaymentElementView();
                this.paymentElementView.createIntent(this.item.cents / 100, BIG_TANGO_FAKE_BOOK);
                this.listenForPayment();
            }
        }

        this.update();
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            url: this.url,
            item: this.item,
            signup: this.signup,
            payment: this.paymentElementView,
            result: this.result,
            renderEuros: renderEuros,
        }

        const out = this.pug(template, data);
        return out;
    }


    notify(n: Notification) {
        if (n instanceof SignupNotification) {
            this.signedUp(n);
        }
        super.notify(n);
    }

    async signedUp(n: SignupNotification) {
        if (n.newUser) {
            // New user, set up again to proceed with payment
            this.setup();
        } else {
            // User already exists
            Alerts.alert({
                message: "There is already a registered user with this email. Please log in first and proceed to the Account page to make your purchase."
            })
        }
    }

    private listenForPayment() {
        if (! this.paymentElementView) {
            return;
        }
        const paid_ = this.paymentElementView.getPromise();
        paid_.then((x) => {
            const pi = x.paymentIntent;
            const amtCents = pi.amount;
            const currency = pi.amount;
            const status = pi.status;
            if (status == "succeeded") {
                this.addOrder(pi);
            }
        });
        paid_.catch(() => {
            this.paymentElementView && this.paymentElementView.newPromise();
            this.listenForPayment();
        });
    }

    async addOrder(paymentIntent: any) {
        const data = await this.server.purchase(paymentIntent);
        this.result = data.result;

        this.update(".result-section");

        this.setup();
    }

}
